export const HELIXOPS_EMAIL_DOMAIN = '@helixops.ai';
export const PENDING_HELIX_EMAIL_KEY = 'pendingHelixOpsEmail';
export const PENDING_HELIX_EMAIL_FALLBACK = `your new ${HELIXOPS_EMAIL_DOMAIN} email address`;

